





























































import Vue from 'vue'
import {
  Query,
  XDayOfWeek,
  DeliveryFrequency,
  DeliveryTimeCandidate,
  Scalars,
} from '@/types/generated/graphql'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import DeliveryTimePicker from '@/components/molecules/DeliveryTimePicker/DeliveryTimePicker.vue'
import DeliveryFrequencyPicker from '@/components/molecules/DeliveryFrequencyPicker/DeliveryFrequencyPicker.vue'
import NumberOfDeliveriesPicker from '@/components/molecules/NumberOfDeliveriesPicker/NumberOfDeliveriesPicker.vue'
import DeliveryDayOfWeekPicker from '@/components/molecules/DeliveryDayOfWeekPicker/DeliveryDayOfWeekPicker.vue'
import nearestShippingDateQuery from '@/graphql/shipping/nearestShippingDate.gql'
import availableDeliveryCountQuery from '@/graphql/shipping/availableDeliveryCount.gql'
import XCard from '@/components/atoms/Card/XCard.vue'
import { dayOfWeekOf } from '@/plugins/moment'

export type Input = {
  deliveryFrequency?: DeliveryFrequency
  numberOfDeliveries?: number
  deliveryDayOfWeek?: XDayOfWeek
  deliveryTimeSlot?: number
}

type Data = {
  shippingDate?: string
  candidates?: DeliveryTimeCandidate[]
}

type Methods = {
  onDeliveryTimeCandidateLoaded: (candidates: DeliveryTimeCandidate[]) => void
}

type Computed = {
  localValue: Input
  deliveryDate?: Scalars['Date']
  timePickerPlaceholder?: string
}

type Props = {
  value: Input
  zipCode: string
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'DeliveryOptions',
  components: {
    XFormLabel,
    DeliveryTimePicker,
    DeliveryFrequencyPicker,
    NumberOfDeliveriesPicker,
    DeliveryDayOfWeekPicker,
    XCard,
  },
  data() {
    return { candidates: [] }
  },
  props: {
    value: {
      type: Object,
    },
    zipCode: {
      type: String,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', { ...this.value, ...value })
      },
    },
    deliveryDate() {
      return this.candidates?.find(
        (candidate) =>
          dayOfWeekOf(candidate.date) === this.localValue.deliveryDayOfWeek
      )?.date
    },
    timePickerPlaceholder() {
      if (!this.zipCode) {
        return this.$tc('ffpAgentHome.zipcodeRequired')
      }
      if (!this.deliveryDate) {
        return this.$tc('ffpAgentHome.deliveryDateRequired')
      }
      return undefined
    },
  },
  methods: {
    onDeliveryTimeCandidateLoaded(candidates) {
      this.candidates = candidates
    },
  },
  apollo: {
    shippingDate: {
      query: nearestShippingDateQuery,
      fetchPolicy: 'network-only',
      variables: { input: { includeStock: true } },
      update: (data: Query) => data.nearestShippingDate,
    },
    availableDeliveryCount: {
      query: availableDeliveryCountQuery,
      fetchPolicy: 'network-only',
    },
  },
})
